"use strict";
/**
 * Standardization Docs
 * https://docs.google.com/document/d/1-X9Cvqterxe0ggcRdNj1cjGPqaNW-w5hyyvzNLGD2_M/edit?usp=sharing
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleKey = exports.resolveLocaleWithMissingInformation = exports.supportLanguages = exports.Romanian_Romania = exports.Spanish_Spain = exports.Spanish_Mexico = exports.Portuguese_Brazil = exports.French_France = exports.French_Canada = exports.German_Germany = exports.Dutch_Netherlands = exports.English_USA = exports.English_IE = exports.English_GB = exports.English_CA = exports.English_AU = void 0;
exports.English_AU = { name: 'English (Australia)', locale: 'en-AU' };
exports.English_CA = { name: 'English (Canada)', locale: 'en-CA' };
exports.English_GB = { name: 'English (Great Britain)', locale: 'en-GB' };
exports.English_IE = { name: 'English (Ireland)', locale: 'en-IE' };
exports.English_USA = { name: 'English (USA)', locale: 'en-US' };
exports.Dutch_Netherlands = { name: 'Nederlands (Nederland)', locale: 'nl-NL' };
exports.German_Germany = { name: 'Deutsch (Deutschland)', locale: 'de-DE' };
exports.French_Canada = { name: 'Français (Canada)', locale: 'fr-CA' };
exports.French_France = { name: 'Français (France)', locale: 'fr-FR' };
exports.Portuguese_Brazil = { name: 'Português (Brasil)', locale: 'pt-BR' };
exports.Spanish_Mexico = { name: 'Español (México)', locale: 'es-MX' };
exports.Spanish_Spain = { name: 'Español (España)', locale: 'es-ES' };
exports.Romanian_Romania = { name: 'Română (România)', locale: 'ro-RO' };
exports.supportLanguages = [
    exports.English_USA,
    exports.Dutch_Netherlands,
    exports.French_Canada,
    exports.Portuguese_Brazil,
    exports.Spanish_Mexico,
    exports.Spanish_Spain,
    exports.Romanian_Romania,
    exports.French_France,
    exports.German_Germany
];
/**
 * Here we are attempting to resolve the locale despite the fact that the locale is missing info. This could be
 * the country code or for some reason the locale is missing a dash/underscore or we only have the country code.
 * This is not meant to be a catch all but a method to try and make sure the user gets a good experience
 * despite the fact that the app has something messed up with the language code.
 *
 * @export
 * @param {string} key the locale string with some information missing.
 * @returns {string}
 */
function resolveLocaleWithMissingInformation(key) {
    switch (key) {
        case 'en':
        case 'US':
        case 'enUS':
            return exports.English_USA.locale;
        case 'es':
        case 'MX':
        case 'esMX':
            return exports.Spanish_Mexico.locale;
        case 'esES':
            return exports.Spanish_Spain.locale;
        case 'pt':
        case 'BR':
        case 'ptBR':
            return exports.Portuguese_Brazil.locale;
        case 'fr':
        case 'FR':
        case 'frFR':
            return exports.French_France.locale;
        case 'frCA':
            return exports.French_Canada.locale;
        case 'ro':
        case 'RO':
        case 'roRO':
            return exports.Romanian_Romania.locale;
        case 'nl':
        case 'NL':
        case 'nlNL':
            return exports.Dutch_Netherlands.locale;
        case 'de':
        case 'DE':
        case 'deDE':
            return exports.German_Germany.locale;
        default:
            return exports.English_USA.locale;
    }
}
exports.resolveLocaleWithMissingInformation = resolveLocaleWithMissingInformation;
/**
 * In an effort to move everyone towards a standardized i18n development
 * process, this function takes the locale key the app is trying to use to set
 * the locale and makes sure it fits our development standards.
 *
 * @param {string} key The locale key used by the app
 */
function getLocaleKey(key) {
    var keyContainsUnderscore = (key || '').match('_');
    var keyContainsDash = (key || '').match('-');
    if (key && keyContainsUnderscore && keyContainsUnderscore.length) {
        // for now we will not show the warning, until the above doc is finalized
        // console.warn( `
        // Your locale keys are using underscores and Jive is moving away from using this. In
        // an effort to standardize our i18n practices. Please change this immediately.
        // `)
        return key.replace('_', '-');
    }
    else if (!key || !keyContainsUnderscore && !keyContainsDash) {
        /**
         * At this point we have determined that the key does not contain a
         * underscore or dash so we are assuming that it is only the language code
         * and that it is missing the country code. We attempt to resolve this.
        */
        return resolveLocaleWithMissingInformation(key);
    }
    else {
        return key;
    }
}
exports.getLocaleKey = getLocaleKey;
//# sourceMappingURL=helpers.js.map